import { computed, ref } from 'vue';

/**
 * Shared QA list pagination state (P2-FE-003).
 */
export function useQaPagination({ defaultPerPage = 25 } = {}) {
  const page = ref(1);
  const perPage = ref(defaultPerPage);
  const meta = ref({
    page: 1,
    per_page: defaultPerPage,
    total_count: 0,
    total_pages: 1,
  });

  const totalPages = computed(() =>
    Math.max(1, Number(meta.value.total_pages || 1))
  );
  const totalCount = computed(() => Number(meta.value.total_count || 0));
  const canPrev = computed(() => page.value > 1);
  const canNext = computed(() => page.value < totalPages.value);

  const applyMeta = nextMeta => {
    const incoming = nextMeta || {};
    meta.value = {
      page: Number(incoming.page || page.value || 1),
      per_page: Number(incoming.per_page || perPage.value || defaultPerPage),
      total_count: Number(incoming.total_count || 0),
      total_pages: Math.max(1, Number(incoming.total_pages || 1)),
      ...incoming,
    };
    page.value = meta.value.page;
    perPage.value = meta.value.per_page;
  };

  const goPage = nextPage => {
    const target = Number(nextPage || 1);
    if (target < 1 || target > totalPages.value) return false;
    page.value = target;
    return true;
  };

  return {
    page,
    perPage,
    meta,
    totalPages,
    totalCount,
    canPrev,
    canNext,
    applyMeta,
    goPage,
  };
}
